// extracted by mini-css-extract-plugin
module.exports = {"FunctionGrid":"AdminLayout_FunctionGrid__3Nqd5","GridItem":"AdminLayout_GridItem__2oYLG","Icon":"AdminLayout_Icon__2dqiS"};